function l(u, a) {
  let t, n = !1, e = !1;
  function r(o) {
    t = o.changedTouches[0].clientX, n = !0;
  }
  function s(o) {
    if (e || !n)
      return;
    const f = o.changedTouches[0].clientX, c = t - f;
    c > 50 ? (e = !0, u()) : c < -50 && (e = !0, a());
  }
  function i() {
    t = 0, e = !1, n = !1;
  }
  return {
    onTouchStart: r,
    onTouchMove: s,
    onTouchEnd: i
  };
}
export {
  l as useTouchNavigation
};
